/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffOverviewEntryUserType } from './StaffOverviewEntryUserType';
import {
    StaffOverviewEntryUserTypeFromJSON,
    StaffOverviewEntryUserTypeFromJSONTyped,
    StaffOverviewEntryUserTypeToJSON,
    StaffOverviewEntryUserTypeToJSONTyped,
} from './StaffOverviewEntryUserType';
import type { UserFacilityAccess } from './UserFacilityAccess';
import {
    UserFacilityAccessFromJSON,
    UserFacilityAccessFromJSONTyped,
    UserFacilityAccessToJSON,
    UserFacilityAccessToJSONTyped,
} from './UserFacilityAccess';

/**
 * 
 * @export
 * @interface StaffOverviewEntry
 */
export interface StaffOverviewEntry {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    user_type_id?: string;
    /**
     * 
     */
    user_type?: StaffOverviewEntryUserType;
    /**
     * 
     */
    email: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    phone?: string;
    /**
     * 
     */
    s3_photo_key?: string;
    /**
     * 
     */
    s3_photo_url?: string;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    last_sign_in_time?: string;
    /**
     * 
     */
    matching_facility_access?: Array<UserFacilityAccess>;
    /**
     * 
     */
    user_facility_accesses?: Array<UserFacilityAccess>;
    /**
     * 
     */
    status?: StaffOverviewEntryStatusEnum;
    /**
     * 
     */
    auth_method?: StaffOverviewEntryAuthMethodEnum;
    /**
     * User's hospital chat signature (max 170 characters)
     */
    hospital_chat_signature?: string;
}


/**
 * @export
 */
export const StaffOverviewEntryStatusEnum = {
    Active: 'active',
    Pending: 'pending',
    Deactivated: 'deactivated',
} as const;
export type StaffOverviewEntryStatusEnum = typeof StaffOverviewEntryStatusEnum[keyof typeof StaffOverviewEntryStatusEnum];

/**
 * @export
 */
export const StaffOverviewEntryAuthMethodEnum = {
    Password: 'password',
    Sso: 'sso',
} as const;
export type StaffOverviewEntryAuthMethodEnum = typeof StaffOverviewEntryAuthMethodEnum[keyof typeof StaffOverviewEntryAuthMethodEnum];


/**
 * Check if a given object implements the StaffOverviewEntry interface.
 */
export function instanceOfStaffOverviewEntry(value: object): value is StaffOverviewEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    return true;
}

export function StaffOverviewEntryFromJSON(json: any): StaffOverviewEntry {
    return StaffOverviewEntryFromJSONTyped(json, false);
}

export function StaffOverviewEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffOverviewEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user_type_id': json['user_type_id'] == null ? undefined : json['user_type_id'],
        'user_type': json['user_type'] == null ? undefined : StaffOverviewEntryUserTypeFromJSON(json['user_type']),
        'email': json['email'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'title': json['title'] == null ? undefined : json['title'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        's3_photo_key': json['s3_photo_key'] == null ? undefined : json['s3_photo_key'],
        's3_photo_url': json['s3_photo_url'] == null ? undefined : json['s3_photo_url'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'last_sign_in_time': json['last_sign_in_time'] == null ? undefined : json['last_sign_in_time'],
        'matching_facility_access': json['matching_facility_access'] == null ? undefined : ((json['matching_facility_access'] as Array<any>).map(UserFacilityAccessFromJSON)),
        'user_facility_accesses': json['user_facility_accesses'] == null ? undefined : ((json['user_facility_accesses'] as Array<any>).map(UserFacilityAccessFromJSON)),
        'status': json['status'] == null ? undefined : json['status'],
        'auth_method': json['auth_method'] == null ? undefined : json['auth_method'],
        'hospital_chat_signature': json['hospital_chat_signature'] == null ? undefined : json['hospital_chat_signature'],
    };
}

export function StaffOverviewEntryToJSON(json: any): StaffOverviewEntry {
    return StaffOverviewEntryToJSONTyped(json, false);
}

export function StaffOverviewEntryToJSONTyped(value?: StaffOverviewEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_type_id': value['user_type_id'],
        'user_type': StaffOverviewEntryUserTypeToJSON(value['user_type']),
        'email': value['email'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'title': value['title'],
        'phone': value['phone'],
        's3_photo_key': value['s3_photo_key'],
        's3_photo_url': value['s3_photo_url'],
        'facility_id': value['facility_id'],
        'last_sign_in_time': value['last_sign_in_time'],
        'matching_facility_access': value['matching_facility_access'] == null ? undefined : ((value['matching_facility_access'] as Array<any>).map(UserFacilityAccessToJSON)),
        'user_facility_accesses': value['user_facility_accesses'] == null ? undefined : ((value['user_facility_accesses'] as Array<any>).map(UserFacilityAccessToJSON)),
        'status': value['status'],
        'auth_method': value['auth_method'],
        'hospital_chat_signature': value['hospital_chat_signature'],
    };
}

